import { Mail } from 'lucide-react'
import type { ComponentProps } from 'react'

import { InputGroup, InputGroupAddon, InputGroupInput } from '@/customer/components/ui/input-group'

/**
 * Email input with a leading mail icon. Thin wrapper over the `InputGroup`
 * primitive; forwards all standard `<input>` props to the underlying control.
 *
 * Uses `type="text"` + `inputMode="email"` rather than `type="email"` so
 * the browser's native validation tooltip doesn't fight with our own
 * inline field errors. Mobile keyboards still show the email layout via
 * `inputMode`, and `autoComplete="email"` keeps password managers happy.
 */
export function EmailInput({
  type = 'text',
  inputMode = 'email',
  autoComplete = 'email',
  ...props
}: ComponentProps<'input'>) {
  return (
    <InputGroup>
      <InputGroupAddon>
        <Mail />
      </InputGroupAddon>
      <InputGroupInput type={type} inputMode={inputMode} autoComplete={autoComplete} {...props} />
    </InputGroup>
  )
}
